/**
 * Case-insensitive de-dupe preserving first-seen casing. Used to merge the
 * Kroll allergy pull with PHOX-registered allergies into one master list
 * (PatientAllergiesCard, Patient 360 header summary).
 */
export function dedupeCi(values: string[]): string[] {
  const seen = new Set<string>();
  const out: string[] = [];
  for (const v of values) {
    const t = v.trim();
    if (!t) continue;
    const key = t.toLowerCase();
    if (seen.has(key)) continue;
    seen.add(key);
    out.push(t);
  }
  return out;
}
